import types from "./type";
import { UserReducerProps } from "./interface";

const initialState: UserReducerProps = {
  userData: null,
  token: null,
  isLogin: false,
  navigationTo: "Dashboard",
};

const userReducer = (state: UserReducerProps = initialState, action: any) => {
  switch (action.type) {
    case types.loginSuccess:
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        token: action.payload.token,
        userData: action.payload,
        isLogin: true,
      };
    case types.logout:
      return initialState;
    case types.setNavigation:
      return {
        ...state,
        navigationTo: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
